
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";

export interface IAddress {
    email: string;
    phone: string;
}

export interface IOpeningHour {
    open: string;
    close: string;
}

export interface ISupportContact {
    description: string;
    external_id: string;
    platform_id: string;
    addresses: IAddress[];
    physical_address: string;
    weekends_opening_hours: IOpeningHour;
    weekdays_opening_hours: IOpeningHour;
    holidays_opening_hours: IOpeningHour;
}

export class SupportContactService extends BaseService {

    protected static instance: SupportContactService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportContactService.instance) SupportContactService.instance = new SupportContactService();
        return SupportContactService.instance;
    }

    querySupportContacts(query: NoseurObject<string | number> = { page: 1, size: 1 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/contact", { cache: true, query: this.normalizeParams(query) }));
    }

}
